<template>
  <div class="more-card">
    <p class="more-title ffm600">{{ title }}</p>
    <p v-if="upgrade.length" class="more-sub-title ffm500">升级：</p>
    <ul v-if="upgrade.length" class="more-des ffm500">
      <li v-for="(item, index) in upgrade" :key="index">
        <span v-if="upgrade.length > 1">{{ item ? `${index + 1}.` : '&nbsp;' }}</span>
        {{ item }}
      </li>
    </ul>
    <p v-if="newThing.length" class="more-sub-title ffm500">新增：</p>  
    <ul v-if="newThing.length" class="more-des ffm500">
      <li v-for="(item, index) in newThing" :key="index">
        <span v-if="newThing.length > 1">{{ item ? `${index + 1}.` : '&nbsp;' }}</span>
        {{ item }}
      </li>
    </ul>
    <p v-if="optimize.length" class="more-sub-title ffm500">优化：</p>
    <ul v-if="optimize.length" class="more-des ffm400">
      <li v-for="(item, index) in optimize" :key="index">
        <span v-if="optimize.length > 1">{{ item ? `${index + 1}.` : '&nbsp;' }}</span>
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "MoreCard",
  props: {
    title: String,
    upgrade: {
      type: Array,
      default: () => [],
    },
    newThing: {
      type: Array,
      default: () => [],
    },
    optimize: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.more-card {
  text-align: left;
  .more-title {
    font-size: 40 * $px1920vw + vw;
    line-height: 48 * $px1920vw + vw;
    color: #000000;
  }
  .more-sub-title {
    font-size: 24 * $px1920vw + vw;
    line-height: 29 * $px1920vw + vw;
    margin-top: 24 * $px1920vw + vw;
    color: #000000;
    margin-bottom: 8 * $px1920vw + vw;
  }
  .more-des {
    font-size: 18 * $px1920vw + vw;
    line-height: 28.8 * $px1920vw + vw;
    color: #666666;
  }
}
.isPad {
  .more-card {
    text-align: left;
    .more-title {
      font-size: 20 * $px676vw + vw;
      line-height: 23 * $px676vw + vw;
      color: #000000;
    }
    .more-sub-title {
      font-size: 12 * $px676vw + vw;
      line-height: 14 * $px676vw + vw;
      margin-top: 11.66 * $px676vw + vw;
      color: #000000;
      margin-bottom: 4 * $px676vw + vw;
    }
    .more-des {
      font-size: 12 * $px676vw + vw;
      line-height: 16 * $px676vw + vw;
      color: #666666;
    }
  }
}

.isMobile {
  .more-card {
    text-align: left;
    .more-title {
      font-size: 14.35 * $px360vw + vw;
      line-height: 15 * $px360vw + vw;
      color: #000000;
    }
    .more-sub-title {
      font-size: 10.5 * $px360vw + vw;
      line-height: 10.5 * $px360vw + vw;
      margin-top: 10 * $px360vw + vw;
      color: #000000;
      margin-bottom: 6 * $px360vw + vw;
    }
    .more-des {
      font-size: 10.5 * $px360vw + vw;
      line-height: 14 * $px360vw + vw;
      color: #666666;
    }
  }
}
</style>